import Minimap from './Minimap';

export default Minimap;
